// dependency-graph-ignore-file
import { dbFieldTypeMap } from '@databases/collab/convert/to-collab';
import { type Database, type MutableDatabase } from '@databases/model/database';
import { type FieldType } from '@databases/model/field';
import { type DatabaseFieldType } from '@databases/types/database';
import {
  isNumericFieldType,
  nonNumericCollabCalculationTypes
} from '@databases/utils/database/collab-calculation-helpers';

export function setFieldType(
  ydb: Database,
  fieldId: string,
  fieldType: DatabaseFieldType
): void {
  function runCalculations(db: MutableDatabase, destType: FieldType) {
    return function calculate(viewId: string) {
      const collabCalculationType = db.viewsById[viewId].calculations[fieldId];

      if (
        collabCalculationType &&
        !isNumericFieldType(destType) &&
        !nonNumericCollabCalculationTypes.includes(collabCalculationType)
      ) {
        db.viewsById[viewId].removeCalculation(fieldId);
      }
    };
  }

  ydb.mutate((db) => {
    const destType = dbFieldTypeMap[fieldType as DatabaseFieldType];

    if (!destType) {
      throw new Error(`Unsupported field type '${fieldType}'`);
    }

    db.fieldsById[fieldId].type = destType;

    db.views.forEach(runCalculations(db, destType));
  });
}
